// extracted by mini-css-extract-plugin
export default {"mainDash":"Dashboard_mainDash__FUl13","topSection":"Dashboard_topSection__YVR3b"};